import "./EditableEntries.css";
import EditableCardEntryInput from "./EditableCardEntryInput";

export function displayEmail(email: string | undefined | null): string {
    if (!email)
        return email ?? "";

    return email.toLowerCase().trim();
}

export function cleanEmail(email: string | undefined | null): string | undefined {
    return email?.trim()?.toLowerCase() ?? email;
}

const EditableCardEntryEmail = ({baseValue, onEdit, isEditing, displayLabel, hyperlinkDisplay}: {
    baseValue: string | undefined | null;
    onEdit: (value: string) => void;
    isEditing: boolean;
    displayLabel: string;
    hyperlinkDisplay?: boolean;
}) => (
    <EditableCardEntryInput type={"email"} onEdit={(v) => {
        onEdit(cleanEmail(v));
    }} isEditing={isEditing} displayLabel={displayLabel} displayValue={hyperlinkDisplay && baseValue ? <a href={`mailto:${cleanEmail(baseValue)}`}>{displayEmail(baseValue)}</a> : displayEmail(baseValue)} baseValue={baseValue} />
);

export default EditableCardEntryEmail;
